module.exports = __webpack_public_path__ + "img/new-version.9a8e1573.png";